import { retrieve } from "./StorageHelper";
import { AUTH_TOKEN } from "../constants/localStorageKeys";

/**
 * Get the user's current timezone in IANA format (e.g., "Asia/Kathmandu")
 * @returns {string} The timezone string
 */
export const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.error("Failed to get timezone:", error);
    // Fallback to UTC if unable to detect
    return "UTC";
  }
};

/**
 * Create axios config with timezone header
 * @param {object} additionalHeaders - Additional headers to include
 * @param {object} additionalParams - Additional params to include
 * @returns {object} Axios config object with headers including timezone
 */
export const createAxiosConfig = (
  additionalHeaders = {},
  additionalParams = {},
) => {
  const token = retrieve(AUTH_TOKEN);

  const config = {
    headers: {
      "X-Timezone": getUserTimezone(),
      ...additionalHeaders,
    },
  };

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (Object.keys(additionalParams).length > 0) {
    config.params = additionalParams;
  }

  return config;
};
